import React, { useState } from "react";
import {
  IonAvatar,
  IonCheckbox,
  IonIcon,
  IonItem,
  IonLabel,
  IonNote,
  IonText,
  isPlatform,
} from "@ionic/react";
import {
  bookmarkOutline,
  calendarOutline,
  documentTextOutline,
  personOutline,
} from "ionicons/icons";
import { Document } from "../../../@types/document";
import { DocumentStatusTag } from "../../../components/Document/DocumentStatusTag";
import { useSelector, useDispatch } from "react-redux";
import { selectSegmentSelected } from "../../../store/documentsSignerList/selectors/selectSegmentSelected";
import { selectMassiveSign } from "../../../store/documentsSignerList/selectors/selectMassiveSign";
import { setCheck } from "../../../store/documentsSignerList";

interface ItemListProps {
  document: Document;
}

export const DocumentItemList: React.FC<ItemListProps> = ({ document }) => {
  const { title, createdAt, author } = document;
  const massiveSign = useSelector(selectMassiveSign);
  const dispatch = useDispatch();
  const [hasFocus, setHasFocus] = useState(false);
  const segment = useSelector(selectSegmentSelected);
  return (
    <IonItem
      routerLink={
        massiveSign && segment === "pending" ? undefined : `/app/acuerdos/firma/${document.id}`
      }
      lines="none"
      class="ion-margin-bottom"
    >
      {isPlatform("desktop") && (
        <IonAvatar slot="start">
          <IonIcon icon={documentTextOutline} size="large" />
        </IonAvatar>
      )}
      {massiveSign && segment === "pending" && (
        <IonAvatar>
          <IonCheckbox
            style={{
              position: "absolute",
              top: "5px",
            }}
            checked={document.checked ? document.checked : false}
            onFocus={() => setHasFocus(true)}
            onIonChange={() => {
              hasFocus && dispatch(setCheck(document)) && setHasFocus(false);
            }}
          />
        </IonAvatar>
      )}

      <IonLabel>
        <h2 style={{ fontWeight: 500 }} className="ion-text-wrap">
          {title}
        </h2>
        <h4>
          <IonIcon icon={personOutline}></IonIcon>
          <IonText class="ion-padding-start">{author?.name}</IonText>
        </h4>
        <p>
          <IonIcon icon={calendarOutline}></IonIcon>
          <IonText class="ion-padding-start">{createdAt}</IonText>

          <IonIcon icon={bookmarkOutline} class="ion-padding-start" />
          <IonText class="ion-padding-start">{`${document.category?.name}`}</IonText>
        </p>
      </IonLabel>
      <IonNote slot="end">
        <DocumentStatusTag document={document} />
      </IonNote>
    </IonItem>
  );
};
